import { render, staticRenderFns } from "./tlpay_set.vue?vue&type=template&id=105a6ace&scoped=true"
import script from "./tlpay_set.vue?vue&type=script&lang=js"
export * from "./tlpay_set.vue?vue&type=script&lang=js"
import style0 from "./tlpay_set.vue?vue&type=style&index=0&id=105a6ace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105a6ace",
  null
  
)

export default component.exports